export default __webpack_public_path__ + "static/media/code.586b5540.svg";